import {withStyles} from '@wix/native-components-infra/dist/es/src/HOC/withStyles/withStyles';
import {withSentryErrorBoundary} from '@wix/native-components-infra/dist/es/src/HOC/sentryErrorBoundary/sentryErrorBoundary';
import {CART_ICON_DSN} from '../../constants';
import {CartIconApp} from './CartIconApp';

export default {
  component: withSentryErrorBoundary(withStyles(CartIconApp, {cssPath: 'cartIcon.min.css'}), {
    dsn: CART_ICON_DSN,
    config: {environment: 'Native Component'},
  }),
};
